import {
  formatCents,
  formatCompetence,
} from "../../utils/directorFormat";

const stateLabel = (state) => ({
  received: "Recebido",
  scheduled: "Previsto",
  unavailable: "Indisponível",
}[state] || "Não classificado");

const CustomerUnitTimeline = ({
  basis = "nominal",
  points = [],
  keyHandover = {},
}) => {
  const segments = points.flatMap((point) => [
    {
      key: `${basis}:${point.period}:received`,
      period: point.period,
      state: "received",
      amountCents: point.receivedAmountCents,
    },
    {
      key: `${basis}:${point.period}:scheduled`,
      period: point.period,
      state: "scheduled",
      amountCents: point.scheduledAmountCents,
    },
  ]);
  const availableAmounts = segments
    .map((item) => item.amountCents)
    .filter((value) => Number.isSafeInteger(value) && value > 0);
  if (keyHandover.state === "available" && Number.isSafeInteger(keyHandover.amountCents)) {
    availableAmounts.push(keyHandover.amountCents);
  }
  const maximum = Math.max(1, ...availableAmounts);
  const keysAvailable = keyHandover.state === "available"
    && Number.isSafeInteger(keyHandover.amountCents);
  const keySegment = {
    key: `${basis}:keys:${keysAvailable ? "available" : "unavailable"}`,
    period: "keys",
    state: keysAvailable ? "scheduled" : "unavailable",
    amountCents: keysAvailable ? keyHandover.amountCents : null,
  };
  const allSegments = [...segments, keySegment];

  return <section className="director-section director-receivables-timeline">
    <header>
      <div>
        <span className="director-eyebrow">Recebido × previsto</span>
        <h2>Movimento da unidade</h2>
      </div>
      <p>Baixas confirmadas e parcelas abertas permanecem em séries separadas.</p>
    </header>
    <div className="director-receivables-legend" aria-label="Legenda da linha do tempo">
      <span><i data-tone="received" />Recebido confirmado</span>
      <span><i data-tone="scheduled" />Ainda previsto</span>
    </div>
    <div aria-label="Gráfico de recebimentos da unidade" className="director-receivables-bars">
      {allSegments.map((item) => {
        const unavailable = item.state === "unavailable";
        const height = Number.isSafeInteger(item.amountCents)
          ? `${Math.max(0, (item.amountCents / maximum) * 100)}%`
          : "0%";
        return <article
          className={`director-receivables-bar-slot director-receivables-bar-slot--${item.state}`}
          data-key={item.key}
          data-testid={item.period === "keys" ? "timeline-keys" : undefined}
          key={item.key}
        >
          <div className="director-receivables-bar-track">
            {!unavailable && <span
              aria-label={`${stateLabel(item.state)} em ${item.period}: ${formatCents(item.amountCents)}`}
              className="director-receivables-bar"
              data-testid="timeline-bar"
              style={{ height }}
            />}
            {unavailable && <strong>Sem fonte</strong>}
          </div>
          <small>{item.period === "keys" ? "Chaves" : formatCompetence(item.period)}</small>
        </article>;
      })}
    </div>

    <details className="director-receivables-timeline-table">
      <summary>Ver valores em tabela</summary>
      <div className="director-table-scroll">
        <table aria-label="Valores mensais de recebimento" className="director-table">
          <thead><tr><th>Período</th><th>Estado</th><th>Valor</th></tr></thead>
          <tbody>
            {allSegments.map((item) => <tr key={`table:${item.key}`}>
              <th scope="row">{item.period === "keys" ? "Chaves" : formatCompetence(item.period)}</th>
              <td>{stateLabel(item.state)}</td>
              <td>{item.state === "unavailable" ? "Indisponível" : formatCents(item.amountCents)}</td>
            </tr>)}
          </tbody>
        </table>
      </div>
    </details>
  </section>;
};

export default CustomerUnitTimeline;
